"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { addNextjsError } from "@datadog/browser-rum-nextjs";
import Image from "next/image";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    addNextjsError(error);
  }, [error]);

  return (
    <div className="fixed inset-0 flex flex-col bg-gradient-to-b from-[hsl(217,50%,21%)] to-[hsl(223,54%,31%)]">
      <header className="pt-safe">
        <div className="flex items-center gap-3 px-4 py-3">
          <Image
            src="https://assets.fluidityiq.ai/assets/fiq-logo-icon-small.png"
            alt="FluidityIQ"
            width={40}
            height={40}
            className="h-10 w-10"
          />
          <Image
            src="https://assets.fluidityiq.ai/assets/fiq-logo.png"
            alt="FluidityIQ"
            width={120}
            height={32}
            className="-mb-[10px] -ml-[10px] h-8"
            style={{ width: 'auto' }}
          />
        </div>
      </header>

      <div className="flex flex-1 items-center justify-center px-6">
        <Card className="w-full max-w-sm rounded-2xl">
          <CardContent className="flex flex-col items-center gap-5 pt-8 pb-8 text-center">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-muted">
              <AlertTriangle className="h-7 w-7 text-muted-foreground" />
            </div>
            <div className="space-y-2">
              <h2 className="text-xl font-semibold">Something went wrong</h2>
              <p className="text-sm leading-relaxed text-muted-foreground">
                An unexpected error occurred. Please try again.
              </p>
            </div>
            <Button
              onClick={reset}
              size="lg"
              className="w-full rounded-xl"
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              Try Again
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
